/* files/export.js — download a doc as Markdown, plain text or a web page. */

import { allTabsJSON } from '../editor/convert.js';
import { textOf } from '../../shared/blocks.js';
import { renderHTML, esc } from '../../shared/render.js';
import { loadKatex, mathHTML } from '../lib/katex.js';
import { toast } from '../ui/ui.jsx';

export function saveBlob(blob, name) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.append(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
}

export const safeName = t => (String(t || 'Untitled document').replace(/[\\/:*?"<>|\u0000-\u001f]+/g, ' ').trim().slice(0, 80) || 'Untitled document');

export async function downloadDoc(sync, title, format) {
  if (!sync) return;
  const json = allTabsJSON(sync.doc);   // every tab, not just the one open
  const name = safeName(title);
  try {
    if (format === 'md') {
      const { toMarkdown } = await import('../lib/markdown.js');
      saveBlob(new Blob([`# ${title || 'Untitled document'}\n\n${toMarkdown(json)}`], { type: 'text/markdown' }), `${name}.md`);
    } else if (format === 'txt') {
      saveBlob(new Blob([`${title}\n\n${textOf(json)}\n`], { type: 'text/plain' }), `${name}.txt`);
    } else {
      await loadKatex().catch(() => {});
      const body = renderHTML(json, { math: mathHTML });
      const page = `<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>${esc(title || 'Untitled document')}</title>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.19.0/dist/katex.min.css">
<style>body{font:17px/1.6 system-ui,sans-serif;max-width:760px;margin:40px auto;padding:0 20px;color:#1f2328}
pre{background:#f4f5f7;padding:12px;border-radius:8px;overflow:auto}table{border-collapse:collapse}td,th{border:1px solid #ccd;padding:6px 10px}
blockquote{border-left:4px solid #ccd;margin:0;padding-left:16px;color:#555}img{max-width:100%}.tasks{list-style:none;padding-left:0}.box{display:inline-block;width:1em}</style>
</head><body><h1>${esc(title || 'Untitled document')}</h1>${body}</body></html>`;
      saveBlob(new Blob([page], { type: 'text/html' }), `${name}.html`);
    }
  } catch (err) {
    toast(err, { kind: 'error' });
  }
}
